import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { injectIntl } from 'react-intl';
import { Input, FormItem, FormText, SapId } from 'ui';
// eslint-disable-next-line
import ReferenceDataDropdown from 'common/reference-data/containers/reference-data-dropdown-container';

// eslint-disable-next-line
class Address extends Component {
  render() {
    const {
      number,
      name,
      name2,
      city,
      postalCode,
      street,
      houseNumber,
      countryKey,
      countryName,
      regionKey,
      regionName,
    } = this.props.data;
    const {
      isEditable,
      form,
      disabled,
      intl,
    } = this.props;
    const { getFieldDecorator } = form;
    const nameValidator = getFieldDecorator('name', {
      initialValue: name,
      rules: [{ required: true, message: intl.formatMessage({ id: 'rules.NAME' }) }],
    });
    const name2Validator = getFieldDecorator('name2', {
      initialValue: name2,
    });
    const streetValidator = getFieldDecorator('street', {
      initialValue: street,
      rules: [{ required: true, message: intl.formatMessage({ id: 'rules.STREET' }) }],
    });
    const houseNumberValidator = getFieldDecorator('houseNumber', {
      initialValue: houseNumber,
      rules: [{ max: 10, message: intl.formatMessage({ id: 'rules.HOUSE_NUMBER' }) }],
    });
    const postalCodeValidator = getFieldDecorator('postalCode', {
      initialValue: postalCode,
      rules: [{ required: true, message: intl.formatMessage({ id: 'rules.POSTAL_CODE' }) }],
    });
    const cityValidator = getFieldDecorator('city', {
      initialValue: city,
      rules: [{ required: true, message: intl.formatMessage({ id: 'rules.CITY' }) }],
    });
    // const countryValidator = getFieldDecorator('countryKey', {
    //   initialValue: countryKey,
    //   rules: [{ required: true, message: 'Please specify a country' }],
    // });

    const transformRegionValues = v => v?.map(o => ({
      ...o,
      name: `${o.name}${o.id ? ` (${o.id})` : ''}`,
    }));

    const regionValidator = getFieldDecorator('regionKey', {
      initialValue: regionKey,
    });

    return (
      <>
        <Row type='flex' gutter={16}>
          <Col md={12} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'common.labels.NAME' })}>
              {isEditable ?
                nameValidator(<Input disabled={disabled} />)
                :
                <FormText data-test-id='info-name'>{name}</FormText>
              }
            </FormItem>
          </Col>
          <Col md={12} sm={24} xs={24} data-test-id='address.name2'>
            <FormItem label={intl.formatMessage({ id: 'common.labels.NAME_2' })}>
              {isEditable ?
                name2Validator(<Input disabled={disabled} />)
                :
                <FormText>{name2}</FormText>
              }
            </FormItem>
          </Col>
        </Row>
        <Row type='flex' gutter={16}>
          <Col md={12} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'common.labels.STREET' })}>
              {isEditable ?
                streetValidator(<Input disabled={disabled} />)
                :
                <FormText>{street}</FormText>
              }
            </FormItem>
          </Col>
          <Col md={12} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'common.labels.HOUSE_NUMBER' })}>
              {isEditable ?
                houseNumberValidator(<Input disabled={disabled} />)
                :
                <FormText>{houseNumber}</FormText>
              }
            </FormItem>
          </Col>
        </Row>
        <Row type='flex' gutter={16}>
          <Col md={12} sm={24} xs={24} data-test-id='address.postalcode'>
            <FormItem label={intl.formatMessage({ id: 'common.labels.POSTAL_CODE' })}>
              {isEditable ?
                postalCodeValidator(<Input disabled={disabled} />)
                :
                <FormText>{postalCode}</FormText>
              }
            </FormItem>
          </Col>
          <Col md={12} sm={24} xs={24} data-test-id='address.city'>
            <FormItem label={intl.formatMessage({ id: 'common.labels.CITY' })}>
              {isEditable ?
                cityValidator(<Input disabled={disabled} />)
                :
                <FormText>{city}</FormText>
              }
            </FormItem>
          </Col>
        </Row>
        <Row type='flex' gutter={16}>
          <Col md={12} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'common.labels.COUNTRY' })}>
              {
                // isEditable
                // ? countryValidator(
                //   <ReferenceDataDropdown
                //     disabled={disabled}
                //     type={'installedat'}
                //     name={'countries'}
                //     valueLabel={'name'}
                //     valueKey={'iso'}
                //   />,
                // )
                // : <FormText>
                //   {countryName}
                // </FormText>
              }
              <FormText>{countryName}</FormText>
            </FormItem>
          </Col>
          <Col md={12} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'common.labels.REGION' })}>
              {isEditable ?
                regionValidator(
                  <ReferenceDataDropdown
                    endpoint={`refdata/lookup/country?iso=${countryKey}`}
                    disabled={disabled}
                    type='installedat'
                    name={`regions_${countryKey}`}
                    valueLabel='name'
                    valueKey='id'
                    valueProperty='regions'
                    transformValues={transformRegionValues}
                  />,
                )
                :
                <FormText>{regionName}</FormText>
              }
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col md={12} sm={24} xs={24} data-test-id='address.sapnum'>
            <FormItem label={intl.formatMessage({ id: 'common.labels.SAP_NUMBER' })}>
              {/* use the ID component to tansform to 'readable' ID (without leading zeroes) */}
              <SapId originalId={number}>{id => <FormText>{id}</FormText>}</SapId>
            </FormItem>
          </Col>
        </Row>
      </>
    );
  }
}

Address.propTypes = {
  data: PropTypes.object,
  isEditable: PropTypes.bool,
  form: PropTypes.object,
  disabled: PropTypes.bool,
  intl: PropTypes.object,
};

export default injectIntl(Address);
